import { useMutation, useQueryClient } from "@tanstack/react-query";
import { callFunction } from "@/lib/supabase";
import type { Operator } from "@/lib/constants";

export function useDeposit() {
  return useMutation({
    mutationFn: async (input: { amount: number; phone: string; operator: Operator }) =>
      callFunction<{ checkout_url: string; transaction_id: string }>("paydunya-deposit", input),
  });
}

// Geniuspay désactivé : on reste uniquement sur PayDunya pour les dépôts.
// Hook conservé commenté pour réactivation rapide si besoin (edge function
// geniuspay-deposit également désactivée côté serveur).
//
// export function useDepositGeniuspay() {
//   return useMutation({
//     mutationFn: async (input: { amount: number; phone?: string }) =>
//       callFunction<{
//         checkout_url: string;
//         transaction_id: string;
//         reference: string;
//       }>("geniuspay-deposit", input),
//   });
// }

export function useWithdrawInit() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: { amount: number; phone: string; operator: Operator }) =>
      callFunction<{ transaction_id: string }>("paydunya-withdraw-init", input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["profile"] });
      qc.invalidateQueries({ queryKey: ["transactions"] });
      qc.invalidateQueries({ queryKey: ["withdrawal", "pending"] });
    },
  });
}
